import { createUUID } from "@commons/uuid"
import { DatahubEventInterface } from "./types/datahubEvent.interface"
import { DataHubInterface } from "./types/datahub.interface"
import { EventInterface } from "./types/event.interface"

export class TrackingEvent implements DataHubInterface {
    private defaultEventProps: DatahubEventInterface

    constructor() {
        this.defaultEventProps = {
            system: "hot_sso",
            entity: "custom_login",
            action: "client_audit",
            event_version: "1.1",
            data_version: "1.0",
            type: "hot_sso-custom_login-client_audit"
        }
    }

    async send(event: EventInterface): Promise<void> {
        const defaultEvent: EventInterface = {
            uuid: createUUID(),
            url: window.location.href,
            userAgent: window.navigator.userAgent,
            template: global.GET_THEME_NAME,
            serviceName: global.GET_SERVICE_NAME
        }
        event = { ...defaultEvent, ...event }

        await global.sendDatahub?.({
            ...this.defaultEventProps,
            event
        } as DatahubEventInterface)
    }
}
